import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Common
      loading: 'Loading...',
      error: 'Error',
      tryAgain: 'Try Again',
      back: 'Back',
      close: 'Close',
      cancel: 'Cancel',
      confirm: 'Confirm',
      submit: 'Submit',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      search: 'Search',
      clear: 'Clear',
      categories: 'Categories',

      // Navigation & Menu
      menu: 'Menu',
      expositions: 'Expositions',
      events: 'Events',
      catalog: 'Catalog',
      contact: 'Contact',
      language: 'Language',
      english: 'English',
      russian: 'Русский',

      // Gallery
      virtualGallery: 'Virtual Gallery',
      startExploring: 'Start Exploring',
      teleportToItem: 'Teleport to Item',
      viewDetails: 'View Details',
      requestInformation: 'Request Information',
      currentExhibition: 'Current Exhibition',
      threeObject: '3D Object',
      painting: 'Painting',
      anySpecificQuestions: 'Any specific questions about this item...',
      clickFloorToMove: 'Click on the floor to move.',
      clickArtworkToView: 'Click on artwork to view details.',
      toLookAround: 'To look around:',
      pcControls: 'PC: Hold left mouse button and drag.',
      mobileControls: 'Mobile: Swipe with your finger.',
      clickToStart: 'Click to start',

      // Events
      eventDetails: 'Event Details',
      registerForEvent: 'Register for Event',
      registrationSuccessful: 'Registration Successful!',
      upcomingEvents: 'Upcoming Events',
      discoverEvents: 'Discover exhibitions, lectures, and special programs',
      allEvents: 'All Events',
      online: 'Online',
      inPerson: 'In-Person',
      onlineEvent: 'Online Event',
      inPersonEvent: 'In-Person Event',
      upcoming: 'Upcoming',
      pastEvent: 'Past Event',
      maxAttendees: 'Maximum Attendees',
      availableSpaces: 'Available Spaces',
      of: 'of',
      eventType: 'Event Type',
      recurring: 'Recurring Event',
      recurringEvent: 'Recurring Event',
      oneTime: 'One-time Event',
      oneTimeEvent: 'One-time Event',
      pattern: 'Pattern',
      schedule: 'Schedule',
      date: 'Date',
      ends: 'Ends',
      location: 'Location',
      submitting: 'Submitting',

      // Catalog
      searchArtworks: 'Search artworks...',
      allExpositions: 'All Expositions',
      allTypes: 'All Types',
      threeObjects: '3D Objects',
      paintings: 'Paintings',
      clearFilters: 'Clear Filters',
      items: 'items',
      item: 'item',
      art: 'Art',
      more: 'more',
      itemDetails: 'Item Details',
      currentlyIn: 'Currently in:',
      dimensions: 'Dimensions',

      // Forms
      name: 'Name',
      fullName: 'Full Name',
      email: 'Email',
      emailAddress: 'Email Address',
      phone: 'Phone',
      phoneNumber: 'Phone Number',
      message: 'Message',
      required: 'Required',
      optional: 'Optional',

      // Contact & Registration
      requestSubmitted: 'Request submitted successfully!',
      contactSoon: 'We\'ll contact you soon with more information.',
      backToEvents: 'Back to Events',
      registerForEventTitle: 'Register for Event',
      requestInfoFor: 'Request more information about',
      anyQuestions: 'Any specific questions about this event...',

      // Error messages
      fillRequiredFields: 'Please fill in all required fields.',
      validEmailRequired: 'Please enter a valid email address.',
      submissionFailed: 'Failed to submit request. Please try again.',
      registrationFailed: 'Failed to register. Please try again.',
      loadingFailed: 'Failed to load. Please try again.',

      // Gallery interaction
      clickToMove: 'Click on the floor to move around',
      clickArtwork: 'Click on artwork to view details',
      yourCurrentLocation: 'Your current location',
      switchRooms: 'Switch rooms and teleport to this item?',
      switchToRoom: 'Switch to this room?',
      teleportToRoom: 'Teleport to Room',
      currentlyInRoom: 'You are currently in',
      switchToRoomMessage: 'Do you want to switch to this exhibition room?',
      itemLocation: 'is located in',
      youAreCurrentlyIn: 'You are currently in',

      // Event Management
      eventTemplates: 'Event Templates',
      eventOccurrences: 'Event Occurrences', 
      createTemplate: 'Create Template',
      generateOccurrences: 'Generate Occurrences',
      templateDetails: 'Template Details',
      occurrenceDetails: 'Occurrence Details',
      recurringPattern: 'Recurring Pattern',
      eventDuration: 'Event Duration (minutes)',
      applyToFutureOccurrences: 'Apply changes to all future occurrences?',
      generateUntilDate: 'Generate until date',
      maxOccurrencesToGenerate: 'Maximum occurrences to generate',
      generatedSuccessfully: 'Occurrences generated successfully',
      templateCreated: 'Event template created successfully',
      occurrenceUpdated: 'Event occurrence updated successfully',
      eventCancelled: 'Event cancelled',
      eventUncancelled: 'Event uncancelled',

      // Tutorial
      welcomeToGallery: 'Welcome to the Virtual Gallery',
      tutorialSkip: 'Skip Tutorial',
      tutorialContinue: 'Continue',
      tutorialGotIt: 'Got it!',
      tutorialCameraControlTitle: 'Camera Control',
      tutorialCameraControlMobile: 'Swipe with one finger to look around',
      tutorialCameraControlDesktop: 'Click and drag to look around',
      tutorialMovementTitle: 'Movement',
      tutorialMovementMobile: 'Use the joystick at the bottom to move. You can also tap the floor to teleport.',
      tutorialMovementDesktop: 'Use WASD or arrow keys to move. You can also click the floor to teleport.',
      tutorialInteractionTitle: 'Interaction',
      tutorialInteraction: 'Click on artworks to get more information about them',
      tutorialMenuTitle: 'Menu & Dashboard',
      tutorialMenu: 'Click the interactive dashboard button in the top left corner to access the gallery catalog and more information',
      tutorialEnjoy: 'Enjoy exploring the virtual gallery!',

      // Misc
      noEventsAvailable: 'No events are currently available.',
      noArtworksFound: 'No artworks found matching your criteria.',
      artworkNotDisplayed: 'This item is not currently displayed in any showroom.',
      thankYouRegistering: 'Thank you for registering for'
    }
  },
  ru: {
    translation: {
      // Common
      loading: 'Загрузка...',
      error: 'Ошибка',
      tryAgain: 'Попробовать снова',
      back: 'Назад',
      close: 'Закрыть',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      submit: 'Отправить',
      save: 'Сохранить',
      delete: 'Удалить',
      edit: 'Изменить',
      view: 'Просмотр',
      search: 'Поиск',
      clear: 'Очистить',

      // Navigation & Menu
      menu: 'Меню',
      expositions: 'Выставки',
      events: 'Мероприятия',
      catalog: 'Каталог',
      contact: 'Контакты',
      language: 'Язык',
      english: 'English',
      russian: 'Русский',      
      categories: 'Категории',

      // Gallery
      virtualGallery: 'Виртуальная галерея',
      startExploring: 'Начать исследование',
      teleportToItem: 'Переместиться к объекту',
      viewDetails: 'Подробности',
      requestInformation: 'Запросить информацию',
      currentExhibition: 'Текущая выставка',
      threeObject: '3D объект',
      painting: 'Картина',
      anySpecificQuestions: 'Есть конкретные вопросы об этом предмете...',
      clickFloorToMove: 'Кликните по полу, чтобы перемещаться.',
      clickArtworkToView: 'Кликните по произведению, чтобы посмотреть детали.',
      toLookAround: 'Чтобы осмотреться:',
      pcControls: 'ПК: Удерживайте левую кнопку мыши и перетаскивайте.',
      mobileControls: 'Мобильные: Проводите пальцем по экрану.',
      clickToStart: 'Кликните, чтобы начать',

      // Events
      eventDetails: 'Детали мероприятия',
      registerForEvent: 'Записаться на мероприятие',
      registrationSuccessful: 'Регистрация успешна!',
      upcomingEvents: 'Предстоящие мероприятия',
      discoverEvents: 'Откройте для себя выставки, лекции и специальные программы',
      allEvents: 'Все мероприятия',
      online: 'Онлайн',
      inPerson: 'Очно',
      onlineEvent: 'Онлайн мероприятие',
      inPersonEvent: 'Очное мероприятие',
      upcoming: 'Предстоящее',
      pastEvent: 'Прошедшее мероприятие',
      maxAttendees: 'Максимум участников',
      availableSpaces: 'Доступно мест',
      of: 'из',
      eventType: 'Тип мероприятия',
      recurring: 'Регулярное мероприятие',
      recurringEvent: 'Регулярное мероприятие',
      oneTime: 'Разовое мероприятие',
      oneTimeEvent: 'Разовое мероприятие',
      pattern: 'Паттерн',
      schedule: 'Расписание',
      date: 'Дата',
      ends: 'Заканчивается',
      location: 'Местоположение',
      submitting: 'Отправка',

      // Catalog
      searchArtworks: 'Поиск произведений...',
      allExpositions: 'Все выставки',
      allTypes: 'Все типы',
      threeObjects: '3D объекты',
      paintings: 'Картины',
      clearFilters: 'Очистить фильтры',
      items: 'предметов',
      item: 'предмет',
      art: 'Искусство',
      more: 'ещё',
      itemDetails: 'Детали предмета',
      currentlyIn: 'Находится в:',
      dimensions: 'Размеры',

      // Forms
      name: 'Имя',
      fullName: 'Полное имя',
      email: 'Электронная почта',
      emailAddress: 'Адрес электронной почты',
      phone: 'Телефон',
      phoneNumber: 'Номер телефона',
      message: 'Сообщение',
      required: 'Обязательно',
      optional: 'Необязательно',

      // Contact & Registration
      requestSubmitted: 'Запрос успешно отправлен!',
      contactSoon: 'Мы свяжемся с вами в ближайшее время для предоставления дополнительной информации.',
      backToEvents: 'Вернуться к мероприятиям',
      registerForEventTitle: 'Записаться на мероприятие',
      requestInfoFor: 'Запросить дополнительную информацию о',
      anyQuestions: 'Есть вопросы по этому мероприятию...',

      // Error messages
      fillRequiredFields: 'Пожалуйста, заполните все обязательные поля.',
      validEmailRequired: 'Пожалуйста, введите корректный адрес электронной почты.',
      submissionFailed: 'Не удалось отправить запрос. Пожалуйста, попробуйте снова.',
      registrationFailed: 'Не удалось зарегистрироваться. Пожалуйста, попробуйте снова.',
      loadingFailed: 'Не удалось загрузить. Пожалуйста, попробуйте снова.',

      // Gallery interaction
      clickToMove: 'Кликните по полу, чтобы перемещаться',
      clickArtwork: 'Кликните по произведению, чтобы посмотреть детали',
      yourCurrentLocation: 'Ваше текущее местоположение',
      switchRooms: 'Переключить зал и перенестись к этому предмету?',
      switchToRoom: 'Перейти в этот зал?',
      teleportToRoom: 'Телепорт в зал',
      currentlyInRoom: 'Вы сейчас находитесь в',
      switchToRoomMessage: 'Хотите перейти в этот выставочный зал?',
      itemLocation: 'находится в',
      youAreCurrentlyIn: 'Вы сейчас находитесь в',

      // Event Management
      eventTemplates: 'Шаблоны мероприятий',
      eventOccurrences: 'События мероприятий',
      createTemplate: 'Создать шаблон',
      generateOccurrences: 'Сгенерировать события',
      templateDetails: 'Детали шаблона',
      occurrenceDetails: 'Детали события',
      recurringPattern: 'Шаблон повторения',
      eventDuration: 'Длительность мероприятия (минуты)',
      applyToFutureOccurrences: 'Применить изменения ко всем будущим событиям?',
      generateUntilDate: 'Генерировать до даты',
      maxOccurrencesToGenerate: 'Максимальное количество событий для генерации',
      generatedSuccessfully: 'События успешно сгенерированы',
      templateCreated: 'Шаблон мероприятия успешно создан',
      occurrenceUpdated: 'Событие мероприятия успешно обновлено',
      eventCancelled: 'Мероприятие отменено',
      eventUncancelled: 'Мероприятие восстановлено',

      // Tutorial
      welcomeToGallery: 'Добро пожаловать в виртуальную галерею',
      tutorialSkip: 'Пропустить обучение',
      tutorialContinue: 'Продолжить',
      tutorialGotIt: 'Понятно!',
      tutorialCameraControlTitle: 'Управление камерой',
      tutorialCameraControlMobile: 'Проводите пальцем по экрану, чтобы осмотреться',
      tutorialCameraControlDesktop: 'Удерживайте левую кнопку мыши и перетаскивайте, чтобы осмотреться',
      tutorialMovementTitle: 'Перемещение',
      tutorialMovementMobile: 'Используйте джойстик внизу для перемещения. Вы также можете нажать на пол, чтобы мгновенно переместиться.',
      tutorialMovementDesktop: 'Используйте клавиши WASD или стрелки для перемещения. Вы также можете нажать на пол, чтобы мгновенно переместиться.',
      tutorialInteractionTitle: 'Взаимодействие',
      tutorialInteraction: 'Нажмите на произведения искусства, чтобы получить больше информации о них',
      tutorialMenuTitle: 'Меню и панель управления',
      tutorialMenu: 'Нажмите кнопку интерактивной панели в левом верхнем углу, чтобы получить доступ к каталогу галереи и дополнительной информации',
      tutorialEnjoy: 'Наслаждайтесь исследованием виртуальной галереи!',

      // Misc
      noEventsAvailable: 'В настоящее время нет доступных мероприятий.',
      noArtworksFound: 'Произведения, соответствующие вашим критериям, не найдены.',
      artworkNotDisplayed: 'Этот предмет в настоящее время не выставлен ни в одном зале.',
      thankYouRegistering: 'Спасибо за регистрацию на'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ru', // Default to Russian
    lng: 'ru', // Force Russian as default language

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],

      // Cache the language selection
      caches: ['localStorage'],

      // Default to Russian
      lookupLocalStorage: 'i18nextLng',
    }
  });

export default i18n;